import { render, staticRenderFns } from "./VabMenuItem.vue?vue&type=template&id=6ba69601&scoped=true"
import script from "./VabMenuItem.vue?vue&type=script&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VabMenuItem.vue?vue&type=style&index=0&id=6ba69601&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba69601",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba69601')) {
      api.createRecord('6ba69601', component.options)
    } else {
      api.reload('6ba69601', component.options)
    }
    module.hot.accept("./VabMenuItem.vue?vue&type=template&id=6ba69601&scoped=true", function () {
      api.rerender('6ba69601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabMenu/components/VabMenuItem.vue"
export default component.exports